import { render, staticRenderFns } from "./herbie.vue?vue&type=template&id=301c3176&"
import script from "./herbie.vue?vue&type=script&lang=js&"
export * from "./herbie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports